import { CARD_TYPE_MAP, LockVendor } from '../config';

export const isBlankCardFn = (vendorInfo, cardInfo) => {
  // console.log('isBlank', vendorInfo, cardInfo);
  // 创佳
  if ([LockVendor.CHUANGJIA, LockVendor.BD, LockVendor.PengZe].includes(vendorInfo?.lockCode)) {
    // 空白卡
    if (cardInfo?.code === 15) {
      return true;
    }
    return false;
  }

  const { cardtype, lockno, effecteddate, expireddate } = cardInfo || {};
  // H21
  if (vendorInfo?.lockCode === LockVendor.H21) {
    if (cardtype === CARD_TYPE_MAP.blank) {
      return true;
    }
    return false;
  }
  // 杨格
  if (!lockno || !effecteddate || !expireddate) {
    return true;
  }
  return false;
};
